import { FC } from 'react';
import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import { WbCardContent, WbTable } from '@agilelab/plugin-wb-platform';
import { Box, makeStyles } from '@material-ui/core';
import { useReleasePageContext } from './context/useReleasePageContext';
import { useReleasesTableColumns } from './hooks/useReleasesTableColumns';
import { ReleaseFilters } from './ReleaseFilters';
import { ReleaseTableNoData } from './ReleaseTableNoData';

const useStyles = makeStyles(
  theme => ({
    table: {
      flex: '1 1 0',
      // instead of filling the container, it becomes height auto on small screens
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 auto',
      },
    },
    content: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
  }),
  { name: 'TechAdapters' },
);

export const ReleaseTable: FC = () => {
  const { releasesState, releases, filters } = useReleasePageContext();
  const columns = useReleasesTableColumns();

  const classes = useStyles();

  const hasData = !!releasesState?.value && !!releases?.length;
  const hasActiveFilters = Object.values(filters).some(
    v => v !== undefined && (Array.isArray(v) ? v.length > 0 : true),
  );
  const showFilters = !!releasesState?.value && (hasData || hasActiveFilters);

  return (
    <WbCardContent className={classes.content}>
      {showFilters && (
        <Box
          style={{
            display: 'flex',
          }}
        >
          <Box style={{ width: '100%' }}>
            <ReleaseFilters />
          </Box>
        </Box>
      )}

      <WbTable<ReleaseAndDeployments>
        stickyHeader
        pinActionsColumnOnMobile={false}
        classNames={{ container: classes.table }}
        components={{
          tableLoader: {
            loading: releasesState?.loading,
          },
          tableContent: {
            columns,
            rows: releasesState?.value ? releases : undefined,
          },
        }}
        noDataComponent={<ReleaseTableNoData />}
      />
    </WbCardContent>
  );
};
